import React from "react";
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const OrderStatus = ({ orderStatus = null, badgeClass = "badge-success" }) => {

    let bcolor = "#1976d2"; // Default theme accent color
    if (orderStatus != null && orderStatus != "") {
        if (orderStatus.toLowerCase() === "manifest closed") {
            bcolor = "#1e7e34";
        } else if (orderStatus.toLowerCase() === "order received" || orderStatus.toLowerCase() === "order created") {
            bcolor = "#17a2b8";
        } else if (orderStatus.toLowerCase() === "voided") {
            bcolor = "#d39e00";
        } else if (orderStatus === "Label Generation Failed") {
            bcolor = "rgb(229 75 86)";
        } else if (orderStatus === "Label Generated" || orderStatus === "Delivered") {
            bcolor = "rgb(52 128 24)";
        }
    }

    return (
        <>
            {!orderStatus && (
                <Typography 
                    variant="body2" 
                    className="tb-lead" 
                    sx={{ color: '#94A3B8', fontWeight: 500, fontSize: '14px' }}
                >
                    -
                </Typography>
            )}
            
            {orderStatus && (
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <Chip 
                        className="sc--orders--chip" 
                        label={orderStatus[0].toUpperCase() + orderStatus.slice(1)} 
                        sx={{ 
                            color: "#FFFFFF", 
                            backgroundColor: bcolor,
                            fontWeight: 700,
                            fontSize: '12px',
                            height: '24px',
                            borderRadius: '6px',
                            px: 0.5,
                            textTransform: 'none',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            transition: 'all 0.15s ease-in-out',
                            '&:hover': {
                                opacity: 0.92,
                                transform: 'scale(1.02)'
                            }
                        }} 
                    />
                </Box>
            )}
        </>
    );
};

export default OrderStatus;